var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUseLicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.9,
    height: 76.515,
    viewBox: "0 0 60.9 76.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "license-svgrepo-com",
    transform: "translate(-50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_30_",
    transform: "translate(50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9038",
    "data-name": "Group 9038",
    transform: "translate(1.51 1.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11545",
    "data-name": "Path 11545",
    d: "M272.565,330.9c5.8-2.9,10.45,1.737,7.551,7.551,2.9,5.8-1.752,10.45-7.551,7.551-5.8,2.9-10.45-1.752-7.551-7.551C262.114,332.64,266.766,328,272.565,330.9Z",
    transform: "translate(-231.297 -279.17)",
    fill: "#50fb56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11546",
    "data-name": "Path 11546",
    d: "M117.88,25.637V83.495H60V10h42.236V25.637ZM108.494,68.78c3-6.02-1.815-10.821-7.822-7.819-6.007-3-10.825,1.8-7.822,7.819-3,6,1.815,10.821,7.822,7.819C106.679,79.6,111.5,74.785,108.494,68.78Z",
    transform: "translate(-60 -10)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11547",
    "data-name": "Path 11547",
    d: "M345.1,25.1H330V10Z",
    transform: "translate(-287.222 -10)",
    fill: "#afb6bb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9039",
    "data-name": "Group 9039",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11548",
    "data-name": "Path 11548",
    d: "M110.9,17.177a1.558,1.558,0,0,0-.453-1.1L94.827.457A1.558,1.558,0,0,0,93.723,0V0H51.562A1.562,1.562,0,0,0,50,1.562V74.954a1.562,1.562,0,0,0,1.562,1.562h57.777a1.562,1.562,0,0,0,1.562-1.562V17.177ZM95.285,5.331l10.284,10.284H95.285ZM53.123,73.392V3.123H92.162V17.177a1.562,1.562,0,0,0,1.562,1.562h14.054V73.392Z",
    transform: "translate(-50)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11549",
    "data-name": "Path 11549",
    d: "M273.043,322.956a6.307,6.307,0,0,0-5.518-2.941,8.913,8.913,0,0,0-3.46.737,8.913,8.913,0,0,0-3.46-.737,6.306,6.306,0,0,0-5.517,2.941,7.578,7.578,0,0,0-.234,7.008,7.568,7.568,0,0,0,.233,7,6.312,6.312,0,0,0,5.524,2.947,8.9,8.9,0,0,0,3.455-.736,8.9,8.9,0,0,0,3.454.736h0a6.312,6.312,0,0,0,5.524-2.948,7.567,7.567,0,0,0,.233-7A7.578,7.578,0,0,0,273.043,322.956Zm-2.777,7.684a4.88,4.88,0,0,1,.209,4.737,3.313,3.313,0,0,1-2.955,1.515,6.249,6.249,0,0,1-2.779-.728,1.51,1.51,0,0,0-1.351,0,6.253,6.253,0,0,1-2.78.728,3.313,3.313,0,0,1-2.955-1.515,4.88,4.88,0,0,1,.209-4.738,1.511,1.511,0,0,0,0-1.349,4.893,4.893,0,0,1-.209-4.745,3.307,3.307,0,0,1,2.949-1.51,6.262,6.262,0,0,1,2.785.729,1.511,1.511,0,0,0,1.351,0,6.26,6.26,0,0,1,2.785-.729,3.308,3.308,0,0,1,2.949,1.51,4.893,4.893,0,0,1-.21,4.746A1.511,1.511,0,0,0,270.265,330.64Z",
    transform: "translate(-221.287 -269.171)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2380",
    "data-name": "Rectangle 2380",
    width: 3.02,
    height: 3.02,
    transform: "translate(40.672 56.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2381",
    "data-name": "Rectangle 2381",
    width: 6.041,
    height: 3.02,
    transform: "translate(39.185 61.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2382",
    "data-name": "Rectangle 2382",
    width: 18.734,
    height: 2.81,
    transform: "translate(6.557 62.465)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2383",
    "data-name": "Rectangle 2383",
    width: 3.747,
    height: 3.747,
    transform: "translate(22.326 67.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2384",
    "data-name": "Rectangle 2384",
    width: 2.81,
    height: 3.747,
    transform: "translate(18.433 67.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2385",
    "data-name": "Rectangle 2385",
    width: 2.81,
    height: 3.747,
    transform: "translate(6.557 67.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2386",
    "data-name": "Rectangle 2386",
    width: 9.367,
    height: 3.747,
    transform: "translate(6.557 5.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2387",
    "data-name": "Rectangle 2387",
    width: 18.734,
    height: 3.747,
    transform: "translate(6.557 10.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2388",
    "data-name": "Rectangle 2388",
    width: 23.418,
    height: 2.81,
    transform: "translate(18.802 23.275)",
    fill: "#50fb56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2389",
    "data-name": "Rectangle 2389",
    width: 47.901,
    height: 2.81,
    transform: "translate(6.557 30.064)",
    fill: "#50fb56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2390",
    "data-name": "Rectangle 2390",
    width: 47.901,
    height: 2.81,
    transform: "translate(6.557 35.883)",
    fill: "#50fb56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2391",
    "data-name": "Rectangle 2391",
    width: 36.532,
    height: 2.81,
    transform: "translate(6.557 42.671)",
    fill: "#50fb56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2392",
    "data-name": "Rectangle 2392",
    width: 3.747,
    height: 2.81,
    transform: "translate(50.711 42.671)",
    fill: "#50fb56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2393",
    "data-name": "Rectangle 2393",
    width: 2.81,
    height: 2.81,
    transform: "translate(46.567 42.671)",
    fill: "#50fb56"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseLicense);
export default __webpack_public_path__ + "static/media/use-license.1c5054f324e0b95931c8abaf5d70d907.svg";
export { ForwardRef as ReactComponent };